import ApiService from "./apiService";
import { GET_CART_DETAILS , CREATE_ORDER , BUY_VOUCHER, GET_VOUCHER, COUPONS_LIST, APPLY_PROMO_CODE } from "../constants/apiEndpoints";
import { getOrCreateGuestUID, isGuestUser } from "../utils/guestHelper";
import { toast } from "react-toastify";

export const getCartDetails = async (forcedGuestUserId = null) => {
  try {
    // If forcedGuestUserId is provided (during cart sync), use it
    if (forcedGuestUserId) {
      const response = await ApiService.get(`${GET_CART_DETAILS}?guestUserId=${forcedGuestUserId}`);
      return response;
    }
    
    // Check if user is guest
    if (isGuestUser()) {
      // Get guest UID
      const guestUID = getOrCreateGuestUID();
      
      // Call API with guestUserId as query parameter
      const response = await ApiService.get(`${GET_CART_DETAILS}?guestUserId=${guestUID}`);
      return response;
    } else {
      // Logged-in user: call API without guestUserId
      const response = await ApiService.get(`${GET_CART_DETAILS}`);
      return response;
    }
  } catch (error) {
    toast.dismiss();
    toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 });
    console.error("Error fetching data:", error);
    return null;
  }
};

export const checkoutCart = async (payload) => {

  try {
    const response = await ApiService.post(CREATE_ORDER,payload);
    return response;
  } catch (error) {
    toast.dismiss();
    toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 });
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getCoupons = async () => {
  try {
    const response = await ApiService.get(`${COUPONS_LIST}`);
    return response;
  } catch (error) {
    toast.dismiss();
    toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 });
    console.error("Error fetching data:", error);
    return null;
  }
};

export const buyVoucher = async (payload) => {
  try {
    // Check if user is guest
    if (isGuestUser()) {
      // Get or create guest UID
      const guestUID = getOrCreateGuestUID();
      
      // Add guestUserId to payload for guest users
      const guestPayload = {
        ...payload,
        guestUserId: guestUID
      };
      
      // Call API with guestUserId
      const response = await ApiService.post(BUY_VOUCHER, guestPayload);
      return response;
    } else {
      // Logged-in user: call API without guestUserId
      const response = await ApiService.post(BUY_VOUCHER, payload);
      return response;
    }
  } catch (error) {
    toast.dismiss();
    toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 });
    console.error("Error buying voucher:", error);
    return null;
  }
};

export const getVoucher = async (voucherId) => {
  try {
    const response = await ApiService.get(`${GET_VOUCHER}/${voucherId}`);
    return response;
  } catch (error) {
    toast.dismiss();
    toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 });
    console.error("Error fetching voucher:", error);
    return null;
  }
};

export const applyPromoCode = async (payload) => {
  try {
    const response = await ApiService.post(APPLY_PROMO_CODE,payload)
    return response;
  } catch (error) {
    toast.dismiss();
    toast.error(error?.response?.data?.message || error?.message, { autoClose: 3000 });
    console.error("Error fetching data:", error);
    return null;
  }
};

